<!--======================================
=            DRAWERHORIZONTAL            =
=======================================-->
<template>

      <v-container class="pa-2 mt-2">
        <v-menu :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" class="white--text"  transition="scroll-y-transition" dark flat v-for="item in menu" :key="item.title" open-on-hover bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
           
            <v-btn text centered   small v-bind="attrs" v-on="on">
              <v-icon   small class="ma-1 pl-2 white--text " dark>
                {{item.action}}
              </v-icon>
             <div class="d-none d-lg-block white--text"> {{item.title}}</div>
            </v-btn>
          </template>

          <v-list :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'"  dark>
            <v-list-item v-for="subItem in item.items" :key="subItem.title" :to="{ path: '/' + subItem.path }">
              <v-list-item-title>{{subItem.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-container>


</template>
<script>
  import menu from "../../util/menu.js"



export default {
    data() {
        return {
            menu:menu, 
        }
    },
    
}
</script>
<style>
.logo-horizontal img{
  width:180px;
  padding:10px;

}
.drawer-horizontal{
  margin-bottom:150px;
}
.card-light {
    border-radius: 1em;
    border: 1px solid rgba(255, 255, 255, 0.5);
    text-shadow: 0 0 1em rgba(0, 0, 0, 0.5);
    background: rgba(255, 255, 255, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  } 
   .card-dark {
    border-radius: 1em;
    border: 1px solid rgba(0, 0, 0, 0.5);
    text-shadow: 0 0 1em rgba(245, 245, 245, 0.5);
    background: rgba(0, 0, 0, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  }

</style>


<!--====  End of DRAWERHORIZONTAL  ====-->
